// JS
import React, { useEffect, useState, useRef } from 'react';
import Button from '../Button';
import { randomId, renderHTML } from '../shared/utils';
import { useMediaQuery } from 'react-responsive';

// COMPONENT
const HeroVideoBackground = ({
  data,
  topMargin = true,
  gaBlockName,
  showHeroVideoBackground = true,
  isLoop = false,
  isAutoPlay = false,
  isControls = true,
  isMuted,
  src
}) => {
  const uniqueId = randomId();
  const isMobile = useMediaQuery({ maxWidth: 767 });

  /* Allows for click on Video to play/pause without controls */
  const [playing, setPlaying] = useState(false);
  const videoRef = useRef(null);
  const handleVideoPress = () => {
    if (playing) {
      videoRef.current.pause();
      setPlaying(false);
    } else {
      videoRef.current.play();
      setPlaying(true);
    }
  };

  useEffect(() => {
    if (!videoRef.current) {
      return;
    }
    if (isMuted) {
      videoRef.current.defaultMuted = true;
      videoRef.current.muted = true;
    }
    videoRef.current.srcObject = src;
  }, [isMuted, src]);

  return (
    <section
      id={'hero-' + uniqueId}
      className={
        showHeroVideoBackground
          ? topMargin
            ? 'my-24 lg:my-48'
            : 'mb-16 lg:mb-32'
          : 'hidden'
      }
    >
      {data &&
        data.map((video, index) => (
          <div
            key={index}
            className={`relative z-0 bg-cover bg-center flex items-end cursor-pointer overflow-hidden aspect-[64/95] md:aspect-[48/25] xl:aspect-[165/65]`}
            data-name={
              video.seven_video_hero_title +
              ' ' +
              video.seven_video_hero_sub_title
            }
            data-creative={gaBlockName}
            data-id={video.contentguid}
            data-position={'banner-slot-' + (index + 1)}
            data-type="banner"
          >
            <video
              //className="relative z-10 md:min-w-full h-full object-cover md:top-1/2 md:left-1/2 md:-translate-x-1/2 md:-translate-y-1/2"
              className="relative z-10 md:min-w-full h-full object-cover"
              onClick={handleVideoPress}
              ref={videoRef}
              loop={isLoop && true}
              autoPlay={isAutoPlay && 'autoplay'}
              controls={isControls && 'controls'}
              muted={isMuted && 'muted'}
              playsInline
              src={
                isMobile
                  ? video.seven_video_hero_url_mobile
                  : video.seven_video_hero_url
              }
            ></video>
            <div
              className={
                'after:absolute after:inset-0 after:z-0 after:w-full after:h-full after:bg-gradient-to-t ' +
                (video.seven_video_hero_white_black &&
                video.seven_video_hero_white_black === 'true'
                  ? 'after:from-black/40 lg:after:from-black/20'
                  : 'after:from-white/50 lg:after:from-white/20')
              }
            ></div>
            <div
              className={
                'absolute left-0 bottom-0 w-full my-10 lg:my-12 uppercase ' +
                (video.seven_video_hero_white_black &&
                video.seven_video_hero_white_black === 'true'
                  ? 'text-white'
                  : 'text-black')
              }
            >
              <div className="container relative mx-auto flex flex-col md:flex-row md:items-center md:justify-between">
                <div className="z-20 text-lg lg:text-6xl mb-24 md:mb-0">
                  <h2 className="font-bold tracking-widest mb-6 md:mb-8">
                    {video.seven_video_hero_title}
                    <p className="font-base">
                      {video.seven_video_hero_sub_title}
                    </p>
                  </h2>
                  {renderHTML(video.seven_video_hero_description, 'text-sm')}
                </div>
                <Button
                  buttonColour={
                    video.seven_video_hero_white_black &&
                    video.seven_video_hero_white_black === 'true'
                      ? 'heroVideo'
                      : 'black'
                  }
                  //buttonColour="black"
                  buttonLink={video.seven_video_hero_url_link}
                  buttonLinkText={video.seven_video_hero_url_text}
                  gaBlockTitle={video.seven_video_hero_url_text}
                  gaBlockName={gaBlockName}
                  gaBlockId={video.contentguid}
                  buttonSlotNumber={index + 1}
                  buttonAdditionalClasses={{
                    classes: 'z-20'
                  }}
                />
              </div>
            </div>
          </div>
        ))}
    </section>
  );
};

export default HeroVideoBackground;
